/**
 * 所有游戏
 *
 * 线上配置地址
 * https://cryolite.memeyule.com/api/v5/nacos/config?dataId=game.yaml&group=cryolite
 *
 *
 * 星际探险 spaceExplore
 * 心愿召唤 wishCall
 * 幸运飞镖 h5Darts
 * 雷电风云战机 leitingzhanji
 * 奇卡对决 towerGame
 * 勇冠三军 h5Sanjun
 * 射箭活动 h5Archery
 * 幸运盲盒 h5LuckyBox
 * 雷电战机传奇 leidianzhanji
 * 幸运大富翁 monopolyGame
 * 时光探秘 spaceTime
 *
 * @author lianghua.fu
 * @date 2024-07-31 14:01:10
 */

import GameModal from './game-modal';

import { hoc, request, user } from 'lib';
import { UiToast } from 'components';
import room from '../../lib/room';

let gameList = [];

const getGameList = async () => {
  if (gameList.length) {
    return gameList;
  }
  return request.cryolite
    .get('api/v5/game-permission/get/v2', {
      room_id: room.getRoomId(),
    })
    .then((res) => {
      gameList = res.data;
      return gameList;
    });
};

/**
 * 打开游戏
 * @param gameInfo 游戏key | 游戏信息
 */
const showGame = async (gameInfo) => {
  if (typeof gameInfo === 'string') {
    gameInfo = (await getGameList()).find((item) => item.name === gameInfo);
  }

  if (!gameInfo) {
    UiToast.warn('无游戏权限或不存在');
    return;
  }

  if (!gameInfo.play) {
    UiToast.warn(gameInfo.playTip);
    return;
  }

  if (gameInfo.needAliRealNameAuth && !user.getUserInfo().identity_auth_game) {
    UiToast.warn('请先前往APP完成实名认证');
    return;
  }

  hoc.render({ key: 'popupGame', gameInfo }, GameModal);
};
export default {
  showGame,
};
